<template>
  <div></div>
</template>

<script>
export default {
  name: "HelpSupportList",
};
</script>

<style lang="scss" scoped></style>
